import {
    undef,
    allowFieldAutoProgress,
    allowInputFieldErrorHighlighting
} from './';

function getFormattedDate(date) {
    return date.toISOString().slice(0, 10);
}

function getNightsCount(checkIn, checkOut) {
    const checkInDate = new Date(checkIn).setHours(0, 0, 0, 0);
    const checkOutDate = new Date(checkOut).setHours(0, 0, 0, 0);

    return Math.round((checkOutDate - checkInDate) / (24 * 60 * 60 * 1000));
}

function hasEmptyDate(date) {
    return !date;
}

function hasEmptyDates(startDate, endDate) {
    return hasEmptyDate(startDate) && hasEmptyDate(endDate);
}

function hasEmptyDatesValues({startDate, endDate}) {
    return hasEmptyDates(startDate, endDate);
}

function hasFilledDate(date) {
    return !hasEmptyDate(date);
}

function hasFilledDates(startDate, endDate) {
    return hasFilledDate(startDate) && hasFilledDate(endDate);
}

function hasFilledDatesValues({startDate, endDate}) {
    return hasFilledDates(startDate, endDate);
}

function hasPartialDates(startDate, endDate) {
    return !hasEmptyDates(startDate, endDate) && !hasFilledDates(startDate, endDate);
}

function hasPartialDatesValues({startDate, endDate}) {
    return hasPartialDates(startDate, endDate);
}

function hasValidDate(date) {
    return hasFilledDate(date);
}

function hasValidDateRange(startDate, endDate) {
    const startTimestamp = Date.parse(startDate);
    const endTimestamp = Date.parse(endDate);

    const todayDate = getFormattedDate(new Date());
    const todayTimestamp = Date.parse(todayDate);

    return (
        startTimestamp >= todayTimestamp &&
        startTimestamp < endTimestamp
    );
}

function hasValidDates(startDate, endDate) {
    return hasValidDate(startDate) && hasValidDate(endDate) && hasValidDateRange(startDate, endDate);
}

function hasValidDatesValues({startDate, endDate}) {
    return hasValidDates(startDate, endDate);
}

function shouldDatesFieldAutoProgressOnClose(mediaSettings, formOptions, datesOptions, latestDatesValues) {
    const {
        isMobile
    } = mediaSettings;

    return (
        isMobile &&
        allowFieldAutoProgress(formOptions, datesOptions) &&
        hasFilledDatesValues(latestDatesValues)
    );
}

function shouldDatesFieldAutoProgressOnSubmit(mediaSettings, formOptions, datesOptions, latestDatesValues) {
    const {
        isMobile
    } = mediaSettings;

    // TODO: Fix on SHCMP-430
    /* istanbul ignore next */
    return (
        !isMobile &&
        allowFieldAutoProgress(formOptions, datesOptions) &&
        hasFilledDatesValues(latestDatesValues)
    );
}

function shouldDatesFieldNotAutoProgressOnCancel(mediaSettings, formOptions, datesOptions) {
    const {
        isMobile
    } = mediaSettings;

    return (
        isMobile &&
        allowFieldAutoProgress(formOptions, datesOptions)
    );
}

function showDatesInputFieldError(mediaSettings, formOptions, datesOptions, latestDatesValues) {
    const {
        isMobile
    } = mediaSettings;

    return !isMobile && (
        allowInputFieldErrorHighlighting(formOptions, datesOptions) && !hasValidDatesValues(latestDatesValues)
    );
}

function showDatesInputIcon(formOptions, datesOptions, id) {
    const showInputIconKey = `showInputIcon${id}`;

    const {
        showIcons
    } = formOptions;

    const {
        [showInputIconKey]: showInputIcon
    } = datesOptions;

    return (
        showInputIcon ||
        showIcons && showInputIcon === undef
    );
}

function showDatesInputIcon1(formOptions, datesOptions) {
    return showDatesInputIcon(formOptions, datesOptions, 1);
}

function showDatesInputIcon2(formOptions, datesOptions) {
    return showDatesInputIcon(formOptions, datesOptions, 2);
}

export {
    getFormattedDate,
    getNightsCount,
    hasEmptyDate,
    hasEmptyDates,
    hasEmptyDatesValues,
    hasFilledDate,
    hasFilledDates,
    hasFilledDatesValues,
    hasPartialDates,
    hasPartialDatesValues,
    hasValidDate,
    hasValidDateRange,
    hasValidDates,
    hasValidDatesValues,
    shouldDatesFieldAutoProgressOnClose,
    shouldDatesFieldAutoProgressOnSubmit,
    shouldDatesFieldNotAutoProgressOnCancel,
    showDatesInputFieldError,
    showDatesInputIcon,
    showDatesInputIcon1,
    showDatesInputIcon2
};
